import React from 'react';

import { l10n } from '@ott/l10n';
import OTTLoadingOverlay from '@ott/loading-overlay';

export const LoadingOverlay = () => {
  return <OTTLoadingOverlay icon="hotels" text={l10n('surcharge.loadingOverlay')} />;
};
